/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Whether the tutor should stay on the current focus or redirect.
 */
export type AiTutorFormativeFeedbackRoutingDecision =
  (typeof AiTutorFormativeFeedbackRoutingDecision)[keyof typeof AiTutorFormativeFeedbackRoutingDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiTutorFormativeFeedbackRoutingDecision = {
  stay: 'stay',
  redirect: 'redirect',
} as const;
